import React from 'react';
import { Modal } from 'react-bootstrap';
import Loader from '../Loader';
import { ILoadingLightboxProps } from './LoadingLightbox.types';

import './LoadingLightbox.scss';

export default function LoadingLightbox(props: ILoadingLightboxProps) {
  return (
    <div data-testid='LoadingLightbox' className='flc_loading-lightbox'>
      <Modal
        {...props}
        show={props.show}
        size='sm'
        aria-labelledby='contained-modal-title-vcenter'
        centered>
        <Modal.Body>
          <div style={{ textAlign: 'center' }}>{props.title}</div>
          <Loader />
        </Modal.Body>
      </Modal>
    </div>
  );
}
